import * as React from "react";
import type { SVGProps } from "react";
const SvgHeadset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      fill="currentColor"
      fillRule="evenodd"
      clipPath="url(#headset_svg__a)"
      clipRule="evenodd"
    >
      <path d="M6 13c-.548 0-1 .452-1 1v2c0 .548.452 1 1 1s1-.452 1-1v-2c0-.548-.452-1-1-1m-3 1c0-1.652 1.348-3 3-3s3 1.348 3 3v2c0 1.652-1.348 3-3 3s-3-1.348-3-3zM18 13c-.548 0-1 .452-1 1v2c0 .548.452 1 1 1s1-.452 1-1v-2c0-.548-.452-1-1-1m-3 1c0-1.652 1.348-3 3-3s3 1.348 3 3v2c0 1.652-1.348 3-3 3s-3-1.348-3-3z" />
      <path d="M12 4c-3.868 0-7 3.132-7 7v3a1 1 0 1 1-2 0v-3c0-4.972 4.028-9 9-9s9 4.028 9 9v3a1 1 0 1 1-2 0v-3c0-3.868-3.132-7-7-7M18 17a1 1 0 0 1 1 1c0 1.413-1.12 2.422-2.312 3.017-1.252.626-2.912.983-4.688.983a1 1 0 1 1 0-2c1.534 0 2.874-.313 3.794-.772.98-.49 1.206-.981 1.206-1.228a1 1 0 0 1 1-1" />
    </g>
    <defs>
      <clipPath id="headset_svg__a">
        <path fill="#fff" d="M3 2h18v20H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHeadset;
